import React, { useState,useEffect } from 'react';
import modelDataEN from '../data/en/model.json';
import modelDataTH from '../data/th/model.json';
import modelDataVN from '../data/vn/model.json';
import modelDataAR from '../data/ar/model.json';
import {useTranslation} from 'react-i18next'
import Slider from "react-slick";
let modelData:any={}
export default function ModelItem(props:any){
  let{t} = useTranslation()
  let capacity:any = sessionStorage.getItem("capacity");
  let feature:any = sessionStorage.getItem("feature")?.split(",");
  let placement:any = sessionStorage.getItem("placement");
  let selectedItem:any = 0;
  
  if(sessionStorage.getItem("lang")==="th"){
    modelData = modelDataTH
  }else if(sessionStorage.getItem("lang")==="vn"){
    modelData = modelDataVN
  }else if(sessionStorage.getItem("lang")==="ar"){
    modelData = modelDataAR
  }else{
    modelData = modelDataEN
  }
  if(sessionStorage.getItem("model")){
    selectedItem = sessionStorage.getItem("model");
  }
 const arrayMatch = (arr1:any, arr2:any)=> {
  let arr:any = [];
  arr1 = arr1.toString().split(',').map(Number);
  arr2 = arr2.toString().split(',').map(Number);

  // for array1
  for (var i in arr1) {
     if(arr2.indexOf(arr1[i]) !== -1)
     arr.push(arr1[i]);
  }


  return arr.sort((x:any,y:any) => x-y);
}

  const filter:any =  modelData.filter((item:any)=>{ 
     let arrfeature:any = [];
      if(item.water_dispenser){
        arrfeature.push(1)
      }
      if(item.auto_ice_maker){
        arrfeature.push(2)
      }
      if(item.vacuum_compartment){
        arrfeature.push(3)
      }
      if(item.auto_door_opening){
        arrfeature.push(4)
      }
      if(item.iot){
        arrfeature.push(5)
      }
      
      if(feature.includes("0")){
        if(parseInt(capacity)===1){
          return parseInt(item.volume)<=570&&!item.water_dispenser&&!item.auto_ice_maker&&!item.vacuum_compartment&&!item.auto_door_opening&&!item.iot
         }else if(parseInt(capacity)===2){
          return parseInt(item.volume)>570&&!item.water_dispenser&&!item.auto_ice_maker&&!item.vacuum_compartment&&!item.auto_door_opening&&!item.iot
         }
      }else{
        let checkFeature:any = arrayMatch(feature,arrfeature);
        if(parseInt(capacity)===1&&checkFeature.length===feature.length){
         return parseInt(item.volume)<=570
        }else if(parseInt(capacity)===2&&checkFeature.length>0){
         return parseInt(item.volume)>570
        }
      }
    })
    
    const [module, setModule] = useState(parseInt(selectedItem));
    const [modelLists, setModelLists] = useState(filter);
    const onSelectRadio=(e:any)=>{
      const {value} = e.target 
      if(e.target.checked){
        setModule(parseInt(value))
        sessionStorage.setItem("model",value)
      }
      console.log("val=>",value)
    }
   
    const onSelectRadioItem=(id:any)=>{
      setModule(parseInt(id))
      sessionStorage.setItem("model",id)
    }
    let perpage:number =3;
    if(modelLists.length<3){
      perpage=2
    }else if(modelLists.length<2){
      perpage=1
    }else{
      perpage=3
    }
    const settings:any = {
      arrows:true,
      dots: true,   
      slidesToShow:perpage,
      slidesToScroll: perpage,
      className: "center",
      centerPadding: "0px",
      centerMode: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: (modelLists.length>=2)?2:1,
            slidesToScroll: (modelLists.length>=2)?2:1,
            infinite: false,
            dots: true,
            centerPadding: "0px",
          }
        },
        {
          breakpoint: 840,
          settings: {
            slidesToShow: (modelLists.length>=2)?2:1,
            slidesToScroll:(modelLists.length>=2)?2:1,
            infinite: false,
            dots: true,
            arrows:false,
            centerPadding: "0px",
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            initialSlide: 1,
            arrows:false,
            centerPadding: "0px",
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:false,
            centerPadding: "32px",
            centerMode: true,
            infinite: false
          }
        },
        {
          breakpoint: 380,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:false,
            centerPadding: "32px",
            centerMode: true,
            infinite: false
          }
        }
      ]
    };
    useEffect(()=>{
     
      console.log("list",modelLists);
      props.onUpdateTotal(modelLists.length)
    },[])
    return (
      <>
      <Slider {...settings}>
      {
        modelLists.map((item:any,key:number)=>
        <div className={`model-item m-auto`} key={`model-item${key}`} onClick={()=>onSelectRadioItem(item.id)}>
            <div className='row model-detail m-0'>
              <div className="col-7 col-sm-8 col-md-8 images px-3">
                  <img src={item.image} alt=""/>
              </div>
              <div className="col-5 col-sm-4 col-md-4 pe-3">
                <div className='size-door'>
                  <div className='door'>
                      {t("door")}
                      <div>{item.door}</div>
                  </div>
                  <div className='size'>
                      {t("volume")}
                      <div>{item.volume}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='model-feature'>
            <div className='row  m-0'>
              {
                (item.auto_ice_maker)?
                <div className={`col-12 col-sm-12 col-md-12 col-lg-${item.feature_column} featureItem`}>
                  <table>
                    <tr>
                      <td><img src="images/icon/ice.png" alt="" className='align-middle'/></td>
                      <td><label className='align-middle'>{t("f_ice")}</label></td>
                    </tr>
                  </table>
                </div>
                :<></>
              }
              {
                (item.water_dispenser)?
                  <div className={`col-12 col-sm-12 col-md-12 col-lg-${item.feature_column} featureItem`}>
                    <table>
                    <tr>
                      <td><img src="images/icon/water.png" alt=""  className='align-middle'/></td>
                      <td><label  className='align-middle'>{t("f_water")}</label></td>
                    </tr>
                  </table>
                  </div>
                :
                <></>
              }
              {
                 (item.auto_door_opening)?
                  <div className={`col-12 col-sm-12 col-md-12 col-lg-${item.feature_column} featureItem`}>
                    <table>
                    <tr>
                      <td><img src="images/icon/hand.png" alt=""  className='align-middle'/></td>
                      <td><label  className='align-middle'>{t("f_door")}</label></td>
                    </tr>
                  </table>
                  </div>
                 :
                 <></>
              }
                 {
                 (item.vacuum_compartment)?
                <div className={`col-12 col-sm-12 col-md-12 col-lg-${item.feature_column} featureItem`}>
                    <table>
                    <tr>
                      <td><img src="images/icon/air.png" alt=""  className='align-middle'/></td>
                      <td><label  className='align-middle'>{t("f_vacuum")}</label></td>
                    </tr>
                  </table>
                </div>
                :
                <></>
                 }
                 {/* {
                 (item.iot)?
                <div className={`col-12 col-sm-12 col-md-12 col-lg-${item.feature_column} featureItem`}>
                    <table>
                    <tr>
                      <td> <img src="images/icon/wifi.png" alt=""  className='align-middle'/></td>
                      <td><label  className='align-middle'>{t("f_iot")}</label></td>
                    </tr>
                  </table>
                </div>
                :
                <></>
                 } */}
            </div>
            <div className='bottom-model'>
              <div className={`title-block  ${(module===parseInt(item.id))?"bg-red":""}`} >
                <div className="m-auto display-inline-block py-1">
                    <input type="radio"   className="radio-btn" name="choice" id={`a-opt${item.id}`} value={item.id} checked={(module===parseInt(item.id))?true:false} onChange={onSelectRadio}/>
                    <label htmlFor={`a-opt${item.id}`} className="radio">{item.model}</label>
                </div>
              </div>
            </div>
            </div>
        </div>
        )}
        </Slider>
        </>
    );
  }
